import {
    Navigate, Outlet,
} from 'react-router-dom'

import authRoles from 'app/authRoles'
import {
    CommonRoutes, DemoPages,
} from 'app/enums/common.enums'
import {
    App,
} from 'app/enums/domain.enums'
import {
    APPS,
} from 'app/SkyNetRoutes/SkyNetRoutes.types'
import {
    ReactComponent as OrdersIcon,
} from 'app/shared-components/images/icons/order.svg'
import Dashboard from 'app/common/Dashboard'
import ActivityRecordsRoutes from 'app/PoC/DataGridDemoPages/ActivityRecordsDemo/ActivityRecords.routes'
import EngagementsDemoRoutes from 'app/PoC/DataGridDemoPages/EngagementsDemo/EngagemensDemo.routes'
import ContactsDemoRoutes from 'app/PoC/DataGridDemoPages/ContactsDemo/ContactsDemo.routes'
import ContractBasisDemoRoutes from 'app/PoC/DataGridDemoPages/ContractBasisDemo/ContractBasisDemo.routes'

const demoLinks = [{
    title: 'Demo',
    id: CommonRoutes.Demo,
    subTitleText: 'Something we are working on',
    icon: OrdersIcon,
    className: 'iconSmall',
    links: [
        {
            title: 'Activity Records',
            id: DemoPages.DemoActivityRecords,
            auth: [
                ...authRoles.dev_team,
                ...authRoles.relationships_ops,
                ...authRoles.relationships_sales,
            ],
            url: '/apps/demo/activity-records-demo',
        },
        {
            title: 'Engagements',
            id: DemoPages.DemoEngagements,
            auth: [
                ...authRoles.dev_team,
                ...authRoles.relationships_sales,
            ],
            url: '/apps/demo/engagements-demo',
        },
        {
            title: 'Contacts',
            id: DemoPages.DemoContacts,
            auth: [...authRoles.dev_team],
            url: '/apps/demo/contacts-demo',
        },
        {
            title: 'Contract Basis',
            id: DemoPages.DemoContractBasis,
            auth: [...authRoles.dev_team],
            url: '/apps/demo/contract-basis-demo',
        },
    ],
}]

export default [
    {
        path: DemoPages.DemoActivityRecords,
        element: <Outlet />,
        children: ActivityRecordsRoutes,
    },
    {
        path: DemoPages.DemoEngagements,
        element: <Outlet />,
        children: EngagementsDemoRoutes,
    },
    {
        path: DemoPages.DemoContacts,
        element: <Outlet />,
        children: ContactsDemoRoutes,
    },
    {
        path: DemoPages.DemoContractBasis,
        element: <Outlet />,
        children: ContractBasisDemoRoutes,
    },
    {
        path: CommonRoutes.Index,
        element: <Dashboard customLinks={demoLinks} />,
    },
    {
        path: CommonRoutes.Asterisk,
        element: <Navigate
            to={`/${APPS}/${App.Dashboard}`}
            replace
        />,
    },
]
